export enum ConnectiveType {
    AND, OR
}

export function getConnectorType(name: string) {
   switch (name) {
       case "&": return ConnectiveType.AND;
       case 'AND': return ConnectiveType.AND;
       case '|': return ConnectiveType.OR;
       case 'OR': return ConnectiveType.OR;
       default: return null;
   }
}